/**
 * HR API Service — barrel re-export (central location).
 *
 * Domain modules live in services/hr/:
 * - personnelApi.js — candidates, personnel, assignments, locations
 * - timesheetApi.js — codes, entries, lock workflow, calendars
 * - payrollApi.js — payslips, bonuses, advances, PDF helpers
 */

import * as personnelApi from './hr/personnelApi';
import * as timesheetApi from './hr/timesheetApi';
import * as payrollApi from './hr/payrollApi';

export * from './hr/personnelApi';
export * from './hr/timesheetApi';
export * from './hr/payrollApi';

const hrApi = {
  ...personnelApi,
  ...timesheetApi,
  ...payrollApi,
};

export default hrApi;
